/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorDeleteResponse = zod
	.object({
		message: zod.string().describe('Success message')
	})
	.describe('Response for successful praetor deletion');

export type PraetorDeleteResponse = zod.input<typeof PraetorDeleteResponse>;
export type PraetorDeleteResponseOutput = zod.output<typeof PraetorDeleteResponse>;
